import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import Icon from "basic-elements/Icon";
import NewLabel from "basic-elements/NewLabel";
import Container from "public-components/Container";
import { Store } from "public-components/StoreProvider";
import { AD } from "feature-sections/AdSection";
import styles from "./Footer.module.scss";

import useSiteFooterEN from "hooks/use-site-footer-en.js";
import useSiteFooterES from "hooks/use-site-footer-es.js";
import useSiteFooterPT from "hooks/use-site-footer-pt.js";
import useSiteFooterRU from "hooks/use-site-footer-ru.js";
import useSiteFooterFR from "hooks/use-site-footer-fr.js";
import useSiteFooterDE from "hooks/use-site-footer-de.js";
import useSiteFooterCN from "hooks/use-site-footer-cn.js";
import useSiteFooterTW from "hooks/use-site-footer-tw.js";
import useSiteFooterJP from "hooks/use-site-footer-jp.js";

const footerDataEnum = {
  "1": useSiteFooterEN,
  "2": useSiteFooterES,
  "3": useSiteFooterPT,
  "4": useSiteFooterRU,
  "5": useSiteFooterFR,
  "6": useSiteFooterDE,
  "7": useSiteFooterCN,
  "8": useSiteFooterTW,
  "9": useSiteFooterJP
};

const Footer = props => {
  const { state } = React.useContext(Store);
  const [data] = React.useState(footerDataEnum[props.siteId]());

  return (
    <footer className={styles.footer}>
      <Container>
        <div
          className={styles.footer__row}
          style={{ display: props.disableAd || state.isVip ? "none" : null }}
        >
          <AD adDivId={data.adType[0].adDivId} adId={data.adType[0].adId} />
        </div>
        <div className={classnames(styles.footer__row, styles.footer__navRow)}>
          {data.footerNavigation.map(i => (
            <nav key={i.footerNavigationTitle} className={styles.footerNav}>
              <h3 className={styles.footerNav__title}>{i.footerNavigationTitle}</h3>
              {i.footerNavigationList.map(j => (
                <div key={j.text} className={styles.footerNav__linkWrap}>
                  <a
                    href={j.href}
                    target={j.openInNewTab ? "_blank" : null}
                    className={styles.footerNav__link}
                  >
                    {j.text}
                  </a>
                  {j.isNew && <NewLabel className={styles.footerNav__linkLabel} />}
                </div>
              ))}
            </nav>
          ))}
        </div>
        <div className={styles.footer__row}>
          <p className={styles.footerCopyright}>{data.copyright}</p>
          <div className={styles.footerSocial}>
            {data.footerSocialMedia.map(i => (
              <a
                key={i.icon}
                href={i.href}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.footerSocial__link}
                aria-label={i.icon}
              >
                <Icon name={i.icon} />
              </a>
            ))}
          </div>
        </div>
      </Container>
    </footer>
  );
};

Footer.defaultProps = {
  siteId: 1,
  disableAd: false
};

Footer.propTypes = {
  siteId: PropTypes.number.isRequired,
  disableAd: PropTypes.bool
};

export default Footer;
